// extracted by mini-css-extract-plugin
export default {"derailmentIcon__container":"hSPifva_5riLZIG7oNpo","high":"c7sYt3jz_DO8vFJfsiB0","veryHigh":"MVoARJUcG1JmlZQJGXwe"};